import React from "react";
import { motion } from "framer-motion";
import "./About.css";

export default function AboutSection() {
  return (
    <section className="about" id="about">

      {/* ABOUT TEXT */}
      <motion.div
        className="about-content"
        initial={{ opacity: 0, x: -40 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.7 }}
      >
        <h2>
          About <span>Our Company</span>
        </h2>

        <p>
          With over <strong>15+ years of excellence</strong>, we are a trusted leader in
          construction, architecture, and interior development.
        </p>

        <p>
          From residential homes to large commercial buildings — we build with
          passion and precision.
        </p>

        <div className="about-stats">
          <div className="stat-box">
            <h3>15+</h3>
            <p>Years Experience</p>
          </div>
          <div className="stat-box">
            <h3>120+</h3>
            <p>Completed Projects</p>
          </div>
          <div className="stat-box">
            <h3>98%</h3>
            <p>Client Satisfaction</p>
          </div>
          <div className="stat-box">
            <h3>50+</h3>
            <p>Professional Team</p>
          </div>
        </div>
      </motion.div>

      {/* ABOUT VIDEO */}
      <motion.div
        className="about-video"
        initial={{ opacity: 0, x: 40 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.7 }}
      >
        <iframe
          src="https://www.youtube.com/embed/vkew-1KK3Sc?autoplay=1&mute=1&controls=0&loop=1&playlist=vkew-1KK3Sc"
          title="Construction Video"
          allow="autoplay; fullscreen"
          loading="lazy"
        ></iframe>
      </motion.div>

    </section>
  );
}
